import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { ActivateSearchIcon, BackArrowIcon, FilterIcon } from "../../Icons";
import apiClient from "../../apiClient";
import { FETCH_USER_WITH_ASSIGNED_RESOURCE_COUNT } from "../../apiClient/apiEndpoints";
import {
  APPLICATION_TAB_TYPE,
  AR_CONTENT_TAB,
  RESOURCE_APPLICATION_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
  RESOURCE_SKILL_STREAM_TAB,
  USER_TAB_TYPE,
} from "../../constant/constants";
import UserInfoPanel from "../InfoPanels/UserInfoPanel";
import ApplicationContent from "../SectionContent/ApplicationContent";
import Breadcrumbs from "../Breadcrumb/Breadcrumbs";
import Create from "../../pages/TeamManagement/create";
import SearchbarMobile from "../ForMobile/SearchbarMobile";
import { useDispatch, useSelector } from "react-redux";
import { saveTotalCount } from "../../store/slice/filterOptions";

const { BackButton, SearchBar, TabNavigator, FilterTab } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const TeamUserManagement = ({ isMobileView }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const configData = useUnoSelector((state) => state.config);
  const filterOptions = useSelector(state => state.filterOptions)
  const UUID = params?.uuid;
  const UNO_URL = configData?.config?.UNO_URL;
  const [search, setSearch] = useState("");
  const [activeCrumb, setActiveCrumb] = useState("");
  const [querySearch, setQuerySearch] = useState("");
  const [userDetails, setUserDetails] = useState({});
  const [defaultTab, setDefaultTab] = useState(RESOURCE_APPLICATION_TAB);
  const [showBackBtn, setShowBackBtn] = useState(true);
  const backClick = () => {
    localStorage.setItem('prevTabHistory', USER_TAB_TYPE)
    navigate(-1);
  }
  const [showFilter, setShowFilter] = useState(false);
  const assignedData = useSelector((state) => state.assignedSlice);
  const moduleSlice = useSelector((state) => state.moduleFilterSlice);
  const applicationData = useSelector((state) => state.applicationSlice);

  const [filterCategoryOption, setFilterCategoryOption] = useState({
    [RESOURCE_APPLICATION_TAB]: [],
    [RESOURCE_MODULE_TAB]: [],
    [RESOURCE_ENVIRONMENT_TAB]: [],
    [RESOURCE_SKILL_STREAM_TAB]: [],
    [RESOURCE_SKILL_SCHOOL_TAB]: [],
    [AR_CONTENT_TAB]: [],
  });

  const [selectedCheckboxes, setSelectedCheckboxes] = useState({
    [RESOURCE_APPLICATION_TAB]: [],
    [RESOURCE_MODULE_TAB]: [],
    [RESOURCE_ENVIRONMENT_TAB]: [],
    [RESOURCE_SKILL_STREAM_TAB]: [],
    [RESOURCE_SKILL_SCHOOL_TAB]: [],
  });


  const getUserDetails = async () => {
    const data = await apiClient.get(`${UNO_URL}${FETCH_USER_WITH_ASSIGNED_RESOURCE_COUNT}/${UUID}`);
    setActiveCrumb(data.group.uuid);
    setUserDetails(data);
    dispatch(saveTotalCount({ data:{ [RESOURCE_APPLICATION_TAB] : data.count.applications } }))
  };

  useEffect(() => {
    if (UUID) getUserDetails();
  }, [UUID]);

  useEffect(() => {
    let resourceFilterOption = moduleSlice?.allModuleCategory?.children?.map((category) => ({
      name: category.name,
      tags: category.tags.map((tag) => ({
        name: tag.name,
        key: tag.id,
        value: tag.id,
        id: tag.id,
        type: category.name.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase(),
      })),
    }));

    let environmentFilterOption = applicationData?.environmentTypes?.children?.map((category) => ({
      name: category.name,
      tags: category.tags.map((tag) => ({
        name: tag.name,
        key: tag.id,
        value: tag.id,
        id: tag.id,
        type: category.name.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase(),
      })),
    }));

    let appCategory = applicationData?.applicationsCategory?.tags || [];
    let applicationFilterOptions = [
      {
        name: "Category",
        tags: appCategory.map((tag) => ({
          name: tag.name,
          key: tag.id,
          value: tag.id,
          id: tag.id,
          type: "Category".replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase(),
        })),
      },
    ];

    setFilterCategoryOption((pre) => ({
      ...pre,
      [RESOURCE_MODULE_TAB]: resourceFilterOption,
      [RESOURCE_APPLICATION_TAB]: applicationFilterOptions,
      [RESOURCE_ENVIRONMENT_TAB]: environmentFilterOption,
    }));
  }, [applicationData, moduleSlice]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setQuerySearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  const openFilter = () => {
    setShowFilter((prev) => (document.body.classList.toggle("filter-active"), !prev));
  };

  const handleSelectApplication = (item) => {
    setSelectedCheckboxes((prev) => {
      const currentArray = prev[defaultTab] || [];

      const exists = currentArray.some((selectedItem) => selectedItem.value === item.value);

      const updatedArray = exists
        ? currentArray.filter((selectedItem) => selectedItem.value !== item.value) // Remove
        : [...currentArray, item];

      return {
        ...prev,
        [defaultTab]: updatedArray,
      };
    });
  };

  const handleResetCheckBox = () => {
    setSelectedCheckboxes((prev) => ({ ...prev, [defaultTab]: [] }));
  };

  const navTabData = [
    {
      id: 1,
      title: "Assigned Application",
      count: filterOptions.total[RESOURCE_APPLICATION_TAB] || null,
      key: RESOURCE_APPLICATION_TAB
    },
  ];


  return (
    <>
      <div className="team-management">
        {!isMobileView ? (
          <div className="page-title with-fuctions">
            <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
            <div className="title-n-breads-wrapper">
              <div className="title-n-breads">
                <p>Team Management </p>
                <span className="separator"> {""} </span>
                <Breadcrumbs UNO_URL={UNO_URL} UUID={UUID} activeCrumb={activeCrumb} />
              </div>
            </div>

            <Create currentTab={APPLICATION_TAB_TYPE} tabType={USER_TAB_TYPE} details={userDetails} />
          </div>
        ) : (
          <div className="mob-header">
            <div className={`page-title mob ${showBackBtn && "with-backBtn"}`}>
              {showBackBtn && (
                <div className="backButtonWrapper">
                  <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
                </div>
              )}
              <div className="mobSearchParent">
                <SearchbarMobile
                  showFilterBtn={true}
                  activeTab={defaultTab}
                  selectedCheckboxes={selectedCheckboxes[defaultTab]}
                  handleResetCheckBox={handleResetCheckBox}
                  handleSelectApplication={handleSelectApplication}
                />
              </div>
            </div>
          </div>
        )}

        <div className="team-functions">
          <div className="team-info">
            <UserInfoPanel
              userDetails={userDetails}
              UUID={UUID}
              params={params}
              isMobileView={isMobileView}
            />
          </div>

          <div className="team-stats for-assigned forUser">
            <TabNavigator
              tabs={navTabData}
              defaultActiveKey={defaultTab}
              nav_wrapper_class={"with-search appUser"}
              // nav_wrapper_class={defaultTab == RESOURCE_APPLICATION_TAB ? "with-search appUser" : "with-search"}
              setActiveTab={setDefaultTab}
            >
              {!isMobileView && (
                <>
                  <div className="search-parent">
                    <SearchBar
                      onClick={() => { }}
                      placeholder="Search..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="filterbtn" onClick={openFilter}>
                    <div className="btninadjust">
                      <FilterIcon />
                      {selectedCheckboxes.length > 0 && <span className="filter-active-span">{""}</span>}
                    </div>
                  </div>

                  <FilterTab
                    showfilter={showFilter}
                    selectedCheckboxes={selectedCheckboxes[defaultTab]}
                    setSelectedCheckboxes={(e) => handleSelectApplication(e)}
                    filterOptions={filterCategoryOption[defaultTab]}
                    onToggleFilter={openFilter}
                    handleResetCheckBox={handleResetCheckBox}
                  />
                </>
              )}
            </TabNavigator>

            <ApplicationContent
              defaultTab={defaultTab}
              setDefaultTab={setDefaultTab}
              selectedFilter={selectedCheckboxes}
              isMobileView={isMobileView}
              UUID={UUID}
              search={querySearch}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamUserManagement;
